import { Outlet } from "react-router-dom";

import { useSystemSettings } from "@/lib/system";

import { Nav } from "./Nav";

export function Layout() {
  const appTitle = useSystemSettings().data?.company.app_title ?? "MES";
  return (
    <div className="min-h-full flex flex-col">
      <Nav />
      <main className="flex-1 container-page py-8 space-y-6">
        <Outlet />
      </main>
      <footer className="container-page py-6 text-xs text-text-muted font-mono border-t border-border mt-12">
        {appTitle} · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
